import script from "./CustomVoiceRead.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomVoiceRead.vue?vue&type=script&lang=ts&setup=true"

import "./CustomVoiceRead.vue?vue&type=style&index=0&id=51b2ed6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b2ed6c"]])

export default __exports__